import { isMobile } from './browser-detection';

/**
 * Check if camera switching is available
 * @param hasVideoPermission - Whether video permission is granted
 * @returns boolean indicating if camera switching is available
 */
export const canSwitchCamera = (hasVideoPermission: boolean = true): boolean => {
  return isMobile() && hasVideoPermission;
};
